// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OrderDetailsGrid_gridContainer__WtElZ","gridOverlay":"OrderDetailsGrid_gridOverlay__36LBs"};